var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"programme-index"},[(_vm.doc)?[_c('slice-body',{attrs:{"slices":_vm.doc.featuredProgramme,"templates":_vm.templates}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }